<template>
  <div id="enrolmentForm">
    <div class="container">
      <div class="datatable-edit__header">
        <h3>Application List</h3>
      </div>

      <el-input v-model="filters[0].value" class="search-datatable mb-3" placeholder="Search" id="inputSearchClassName">
        <template slot="prepend">
          <i class="material-icons">search</i>
          <span>Search</span>
        </template>
      </el-input>
      <!--Start By Ryan on adding loading icon-->
      <div v-if="listCount===0" class="emptylist-info">
        <div class="emptylist__img">
          <img src="../assets/table-loading.png"/>
        </div>
      </div>
      <!--End By Ryan on adding loading icon-->
      <div v-if="listCount>0" class="datatable_group">
        <template>
          <el-tabs type="card" @tab-click="handleClick">
            <el-tab-pane label="Pending">
              <div class="pendingList"><h4>Pending</h4></div>
              <data-tables :filters="filters"
                :data="enrolListInt" :action-col="enrolActionCol">
                <el-table-column v-for="items in enrolList" :prop="items.prop"
                                 :label="items.label" :key="items.prop"
                                 sortable="custom">
                </el-table-column>
              </data-tables>
            </el-tab-pane>
            <el-tab-pane label="Reviewing">
              <div class="reviewingList"><h4>Reviewing</h4></div>
              <data-tables :filters="filters"
                :data="reviewListInt" :action-col="reviewActionCol">
                <el-table-column v-for="items in reviewList" :prop="items.prop"
                                 :label="items.label" :key="items.prop"
                                 sortable="custom">
                </el-table-column>
              </data-tables>
            </el-tab-pane>
            <el-tab-pane label="Draft">
              <div class="pendingList"><h4>Draft</h4></div>
              <data-tables :filters="filters"
                :data="draftListInt" :action-col="draftActionCol">
                <el-table-column v-for="items in draftList" :prop="items.prop"
                                 :label="items.label" :key="items.prop"
                                 sortable="custom">
                </el-table-column>
              </data-tables>
            </el-tab-pane>
            <el-tab-pane label="Rejected">
              <div v-if="rejectedListInt.length > 0">
                <div class="rejectedList"><h4>Rejected</h4></div>
                <data-tables :filters="filters"
                  :data="rejectedListInt" :action-col="rejectedActionCol">
                  <el-table-column v-for="items in rejectedList" :prop="items.prop"
                                   :label="items.label" :key="items.prop"
                                   sortable="custom">
                  </el-table-column>
                </data-tables>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Approved">
              <div v-if="approvedListInt.length > 0">
                <div class="approvedList"><h4>Approved</h4></div>
                <data-tables :data="approvedListInt" :action-col="approvedActionCol" :filters="filters">
                  <el-table-column v-for="items in approvedList" :prop="items.prop"
                                   :label="items.label" :key="items.prop"
                                   sortable="custom">
                  </el-table-column>
                </data-tables>
              </div>
            </el-tab-pane>
          </el-tabs>
        </template>
      </div>
      <div class="emptylist-info" v-else>
        <div class="emptylist__img">
          <img src="../assets/table-loading.png"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from "../data/datasource";
import {lang} from '../locale/index';
import Cookies from "js-cookie";
import { getFormatDate } from "@/helper/utily";

const columns = [
  {prop: "APF_CreatedOnFormatted", label: "Created Date"},
  {prop: "APF_FirstName", label: "First Name"},
  {prop: "APF_Surname", label: "Last Name"},
  {prop: "DetailedStatus", label: "Enrolment Status"},
  {prop: "CommencementDate", label: "Commencement Date"},
  {prop: "APF_IDType", label: "ID Type"},
  {prop: "AcademicYear", label: "Academic Year"},
  {prop: "AcademicLevel", label: "Academic Level"},
];

const actionCol = {
  label: lang('More'),
  props: { align: 'center' },
  buttons: [{
    props: {type: 'primary', icon: 'el-hand-up'},
    // handler: row => { window.open('/ApplicationManagement?id=' + row.APF_ID, "_blank"); },
    handler: row => { VUE.$router.push(`/ApplicationManagement?id=${row.APF_ID}`) },
    label: lang('View'),
  }]
}

export default {
  name: "ApplicationList",
  data() {
    return {
      listCount: '',
      enrolListInt: [],
      enrolList: columns,
      enrolActionCol: actionCol,

      reviewListInt: [],
      reviewList: columns,
      reviewActionCol: actionCol,

      rejectedListInt: [],
      rejectedList: columns,
      rejectedActionCol: actionCol,

      approvedListInt: [],
      approvedList: columns,
      approvedActionCol: actionCol,

      draftListInt: [],
      draftList: columns,
      draftActionCol: actionCol,

      filters: [
        {
          value: "",
          prop: ["APF_FirstName","APF_Surname"]
        }
      ]
    }
  },
  async mounted() {
    window.VUE = this;
    await this.getApplicationList();
  },
  methods: {
    lang,
    async getApplicationList() {
      this.$vs.loading();

      const resp = await DataSource.shared.getApplicationList(Cookies.get('schoolSession'));

      if (resp.code === '2') {
        this.$notify.error({
          title: 'Data not found',
          message: 'Data not found!',
        });
      } else {
        this.listCount = resp.length;

        resp.forEach(m => {
          m.CommencementDate = m.APF_CommencementDate?.slice(0, 10);
          m.DetailedStatus = m.APF_Status === 'Pending' && m.ApprovedCount > 0 ? 'Reviewing' : m.APF_Status;
          m.APF_CreatedOnFormatted = getFormatDate(m.APF_CreatedOn,"YYYY-MM-DD")
          if (m.DetailedStatus === 'Reviewing')
            this.reviewListInt.push(m);
          else if (m.APF_Status === 'Approved')
            this.approvedListInt.push(m);
          else if (m.APF_Status === 'Rejected')
            this.rejectedListInt.push(m);
          else if (m.APF_Status === 'Pending')
            this.enrolListInt.push(m);
          else if (m.APF_Status === 'Draft')
            this.draftListInt.push(m);
        });
      }
      this.$vs.loading.close();
    },
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
}
</script>

<style scoped>
.pendingList {
  background-color: rgb(144, 179, 243);
  width: 100%;
  border-radius: 5px;
  color: white;
}

.approvedList {
  background-color: rgb(17, 100, 0);
  width: 100%;
  border-radius: 5px;
  color: white;
}

.rejectedList {
  background-color: red;
  width: 100%;
  border-radius: 5px;
  color: white;
}

.el-table td {
  padding: 1px 0;
}
</style>